import { TPlanCode } from "@/types/TSubscription";

/** Display names of the plans, keyed by code — the API's `name` is not in a 402. */
export const PLAN_NAMES: Record<TPlanCode, string> = {
	free: "Free",
	user: "User",
	user_plus: "User+",
	team: "Team",
	team_plus: "Team+",
	enterprise: "Enterprise",
};
